<template>
    <div class="relative overflow-hidden border-b border-gray-100 bg-gradient-to-b from-primary-50/60 to-white">
        <div class="mx-auto max-w-7xl px-6 py-16 sm:py-20 lg:px-8">
            <nav aria-label="Breadcrumb">
                <ol role="list" class="flex flex-wrap items-center gap-2 text-sm">
                    <li v-for="breadcrumb in breadcrumbs" :key="breadcrumb.name" class="flex items-center gap-2">
                        <router-link :to="breadcrumb.href" class="font-medium text-gray-500 hover:text-primary-600">
                            {{ breadcrumb.name }}
                        </router-link>
                        <ChevronRightIcon class="size-4 text-gray-300" aria-hidden="true" />
                    </li>
                    <li class="font-medium text-gray-900">{{ title }}</li>
                </ol>
            </nav>

            <div class="mt-6 flex flex-col gap-10 lg:flex-row lg:items-center lg:justify-between">
                <div class="max-w-2xl">
                    <h1 class="text-3xl font-semibold tracking-tight text-gray-900 sm:text-4xl">{{ title }}</h1>
                    <p v-if="description" class="mt-4 text-lg/8 text-gray-600">{{ description }}</p>
                </div>
                <div v-if="image" class="shrink-0 lg:w-72">
                    <img :src="image" :alt="title" class="aspect-4/3 w-full rounded-2xl object-cover shadow-lg" />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ChevronRightIcon } from '@heroicons/vue/20/solid';

defineProps({
    title: { type: String, required: true },
    description: { type: String, default: '' },
    image: { type: String, default: '' },
    breadcrumbs: { type: Array, default: () => [{ name: 'Home', href: '/' }] },
});
</script>
